// extracted by mini-css-extract-plugin
export default {"summary-container":"ModeConfigPricingReportSummary_summary-container__vSdJE","summary-ctas":"ModeConfigPricingReportSummary_summary-ctas__W8kQM"};